module.exports = function getResource(label, vars = []) {
    let resources = {
        byClicking: 'En cliquant sur « S’inscrire », vous reconnaissez être résident des États-Unis ou du Canada ' +
            'et acceptez la',
        privacyPolicy: 'Politique de confidentialité',
        termsOfUse: 'les conditions d’utilisation et les',
        and: 'et ',
        biTerms: 'modalités Beauty Insider',
        receiveOffers: 'et de recevoir automatiquement les offres Beauty Insider ainsi que ' +
            'des notifications par courriel.',
        sephoraReCaptchaText: 'Sephora utilise ReCaptcha et les utilisateurs sont assujettis',
        sephoraReCaptchaTextRegister: 'Sephora utilise ReCaptcha, et en s’enregistrant, les utilisateurs sont assujettis aux normes de Google en matière de',
        googlePrivacyPolicyLink: 'politique de confidentialité',
        googleTermsLink: 'conditions'
    };
    return resources[label];
};
